var zooomyBT= ($js)=>{
		var shop = "";
		var lang_s = "";
		var customer_email = "";
		var customer_name = "";
		var scripts = document.getElementsByTagName('script');
		for (var i = 0, l = scripts.length; i < l; i++) {
			if (scripts[i].getAttribute('data-shop') != null) {
				shop = scripts[i].getAttribute('data-shop');
			}
			if (scripts[i].getAttribute('data-customer') != null || scripts[i].getAttribute('data-customer') != "") {
				customer_email = scripts[i].getAttribute('data-customer');
			}
			if (scripts[i].getAttribute('data-customer-name') != null || scripts[i].getAttribute('data-customer-name') != "") {
				customer_name = scripts[i].getAttribute('data-customer-name');
			}
			if (scripts[i].getAttribute('data-handle') != null) {
				product_handle = scripts[i].getAttribute('data-handle');
			}
			if (scripts[i].getAttribute('data-product-id') != null) {
				bisproduct_id = scripts[i].getAttribute('data-product-id');
			}


		}
			
if (!shop || !shop.includes('myshopify')) {
    shop = Shopify.shop;
}

		//product_id = meta.product.id;
		product_id = bisproduct_id;
		if (product_id == "" || product_id == null || product_id == undefined) {
			product_id = bisproduct_id;
		}

		ZooomyStock(shop, product_handle, product_id, customer_email);

		function ZooomyStock(shop, product_handle, product_id, customer_email) {

			$js.ajax({ 
				url: "https://zooomyapps.com/backinstock/ZooomyBackinStockjson.php",
				data: {
					shop: shop,
					product_id: product_id
				},
				dataType: "jsonp",
				jsonp: "jsonCode",
				async: "true",
				success: function(jsonData) {
					var shop = jsonData.shop;
					var lang_s = "";
					var back_in_stock_text = jsonData.back_in_stock_text;
					var add_font_size = jsonData.add_font_size;
					var add_border_radius = jsonData.add_border_radius;
					var add_border_width = jsonData.add_border_width;
					var add_border_color = jsonData.add_border_color;
					var add_background_color = jsonData.add_background_color;
					var add_font_color = jsonData.add_font_color;
					var back_in_stock_width = jsonData.back_in_stock_width;
					var main_heading = jsonData.main_heading;
					var sub_heading = jsonData.sub_heading;
					var main_heading_color = jsonData.main_heading_color;
					var main_heading_size = jsonData.main_heading_size;
					var sub_heading_color = jsonData.sub_heading_color;
					var sub_heading_size = jsonData.sub_heading_size;
					var admin_email = jsonData.admin_email;
					var quantity = jsonData.quantity;
					var notify_msg = jsonData.notify_msg;
					var notify_emsg = jsonData.notify_emsg;
					var ccss = jsonData.ccss;
					var email_placeholder = jsonData.email_placeholder;
					var user_added_css = jsonData.user_added_css;
					var autoemail = jsonData.autoemail;
					var send_email = jsonData.checkdata;
					var shop_token = jsonData.shop_token;
					var branding = jsonData.branding;
					var tc_txt = jsonData.tc_txt;
					var lay = jsonData.lay;
					var znlsignup = jsonData.znlsignup;
					var znltxt = jsonData.znltxt;
					var maillist = jsonData.maillist;
					if (Shopify.locale != "") {
						lang_s = Shopify.locale;

					}
					var checktrue = "yes";
					var double_opt = jsonData.double_opt_enable;
					var znlcheck = "";
					var me = "";
					var protitle = "";
					var proprice = "";
					var proimg = "";
					var vnames = "";
					var vtitle = "";
					var variant_img = "";
					var vsku = "";
					var vid = "";
                    var bislayout="nopopup";



					if (customer_email == "null" || customer_email == null) {
						customer_email = "";
					}
					let product_handleIs=window.location.pathname
					$js("#zooomybackinstock").hide();
					$js.ajax({
						url: product_handleIs + '.js',
						dataType: 'json',
						success: function(cartvalues) {
							protitle = cartvalues.title;
							proprice = cartvalues.price;
							proimg = cartvalues.featured_image;


             
					$js('<style>share-button.share-button{clear:both;}.product-description.rte, .product-single__description.rte{clear:both;}#zooomybackinstock #zooomyalertemail, #zooomybackinstock #zooomyalertbtn{width:100%;max-width:100%;box-sizing:border-box; margin:5px 0px;text-align:center;}.zbackinstock__headings .zooomyh3{float:left;width:100%;text-align:center; font-size:' + main_heading_size + '; color:' + main_heading_color + ';}</style>').appendTo("body");
					$js('<style>.product-single__description.rte, .product__accordion.accordion { clear: both; }.zheading__text{float:left;width:100%;text-align:center; font-size:' + sub_heading_size + '; color:' + sub_heading_color + '}</style>').appendTo("body");
					$js('<style>#zooomyalertbtn{float:right; width:28%;padding:14px;background:' + add_background_color + '; color:' + add_font_color + ';font-size:' + add_font_size + ';border-radius:' + add_border_radius + ';border:' + add_border_width + ' solid ' + add_border_color + ';}</style>').appendTo("body");
					$js('<style>#zooomybackinstock .zooomyformbis{float:left;width:100%;margin:0; padding:10px 0px;}#zooomybackinstock { margin:20px 0px;float: left; width: 100%; border: 1px solid #ededed; text-align:center; padding: 20px; box-sizing: border-box; }#zooomyalertemail {padding: 14px;box-sizing: border-box; float: left; width: 70%; }</style>').appendTo("head");
					$js('<style>#zooomyalertbtn, .zbis-notify-btn{cursor:pointer;}.zbis-notify-btn{padding:14px;background:' + add_background_color + '; color:' + add_font_color + ';font-size:' + add_font_size + ';border-radius:' + add_border_radius + ';border:' + add_border_width + ' solid ' + add_border_color + ';width:100%;float:left;margin:10px auto;}</style>').appendTo("body");

					if (bislayout == "nopopup") {
					    // Only update if content is not already added
					    if ($js("#zooomybackinstock .zooomyh3").length === 0) 
					    {
					        $js("#zooomybackinstock").html(
					            "<div class='zbackinstock__headings'><div class='zooomyh3'>" + main_heading + "</div><div class='zheading__text'>" + sub_heading + "</div></div>" +
					            "<div class='zooomyformbis'><input type='email' name='zooomyalertemail' id='zooomyalertemail' placeholder='" + email_placeholder + "' value='" + customer_email + "'/><a class='zooomybtn zooomybutton' id='zooomyalertbtn'>" + back_in_stock_text + "</a></div>"
					        );
					    }
					}

					if (bislayout == "popup") {
					    zooomyPopup();
					    // Only append if content is not already added
					    if ($js(".custom-zooomymodel-main .pop-up-content-wrap .zooomyh3").length === 0) {
					        $js(".custom-zooomymodel-main .pop-up-content-wrap").append(
					            "<div class='zbackinstock__headings'><div class='zooomyh3'>" + main_heading + "</div><div class='zheading__text'>" + sub_heading + "</div></div>"
					        );
					        $js(".custom-zooomymodel-main .pop-up-content-wrap").append(
					            "<div class='zooomyformbis'><input type='email' name='zooomyalertemail' id='zooomyalertemail' placeholder='" + email_placeholder + "' value='" + customer_email + "'/><a class='zooomybtn zooomybutton' id='zooomyalertbtn'>" + back_in_stock_text + "</a></div>"
					        );
					    }

						if(cartvalues.variants.length < 2 && cartvalues.available == false)
						{
						}
						else
						{
						 $js(".pop-up-content-wrap .zbackinstock__headings").after('<div class="zbisselectwrap"  id="zbisselectwrap-'+cartvalues.id+'"><select name="zbisselect-'+cartvalues.id+'" class="zbisselect zbisselect-'+cartvalues.id+'"></select></div>');

						 $js(cartvalues.variants).each(function(k, variants) 
						 {     
						 	console.log(variants);
						if(variants.featured_image != null)
						{
						 var vimg=variants.featured_image.src;
						}  
						else
						{
						 var vimg=cartvalues.featured_image;

						}

						$js(".pop-up-content-wrap .zbisselect-"+cartvalues.id).append("<option value='"+variants.id+"' data-id='"+variants.id+"' data-sku='"+variants.sku+"' data-name='"+variants.title+"' data-image='"+vimg+"' data-price='"+variants.price+"' data-available='"+variants.available+"'>"+variants.title+"</option>");                             


						 });    

						}

					}



							if (znlsignup == "yes") 
							{
							if ($js("#zooomybackinstock  .zooomyneslettersignup").length === 0) 
							{		
						
								$js("#zooomybackinstock .zooomyformbis").append("<div class='zooomyneslettersignup'><div class='ZbisNewsSign'><input type='checkbox' id='zbisnl' /><label for='zbisnl'>" + znltxt + "</label><span class='clear'></span></div></div>");
								$js('<style>.ZbisNewsSign{ width: 100%; padding: 10px 0; display: flex; align-items: center; justify-content: center; gap: 8px; } .ZbisNewsSign input[type="checkbox"]{ margin: 0; height: 14px; width: 17px; min-height: 0; } .ZbisNewsSign label{ margin: 0; cursor: pointer; line-height: 1.4; } </style>`).appendTo("body");</style>').appendTo("body");
							}
						   }



							if (branding == "yes" && $js("#zooomybackinstock .zbranding").length === 0) {
								$js("#zooomybackinstock").append("<div class='zbranding' style='opacity:1!important;margin:2px 0;display:block!important;visibility:visible!important;font-weight:bold;font-size:14px!important;color:#333!important;float:left;width:100%;padding:5px 0;z-index:initial!important;margin:0!important;position:unset!important;display:block!important;'>Powered by <a style='color:#333;text-decoration:underline;display:inline!important;opacity:1!important;' href='https://apps.shopify.com/partners/zoomyapps' target='_blank'>Zooomy</a></div>");
								setTimeout(function() {
									if (document.querySelector('#zooomybackinstock > div.zbranding').innerHTML === "") {
										$js('.zbranding').replaceWith("<div style='opacity:1!important;margin:2px 0;visibility:visible!important;font-weight:bold;font-size:14px!important;color:#333!important;float:left;width:100%;padding:5px 0;z-index:initial!important;margin:0!important;position:unset!important;display:block!important;'>Powered by <a style='color:#333;text-decoration:underline;display:inline!important;opacity:1!important;' href='https://apps.shopify.com/partners/zoomyapps' target='_blank'>Zooomy</a></div>");
									}
								}, 2000);


							}



							if (jsonData.double_opt_enable == "yes" && $js("#zooomybackinstock .zooomydoubleoptin").length === 0) {
								checktrue = "no";
								$js("<div class='zooomydoubleoptin'><input type='checkbox' id='zooomydoubleopt_Check'><label for='zooomydoubleopt_Check'>" + jsonData.double_opt_txt + "</label><span style='clear:both'></span></div>").insertAfter('#zooomyalertbtn');
								$js('<style>#zooomyalertbtn { opacity:0.6;pointer-events:none;}.zooomydoubleoptin{ display: inline-block; } .zooomydoubleoptin input[type="checkbox"]{ vertical-align: middle; margin-right: 6px; } .zooomydoubleoptin label{ vertical-align: middle; }</style>').appendTo("body");
								$js('#zooomydoubleopt_Check').change(function() {
									if ($js('input#zooomydoubleopt_Check').prop('checked')) {
										checktrue = "yes";
										$js('<style>#zooomyalertbtn { opacity:1;pointer-events:all;}</style>').appendTo("body");
										double_opt = "yes";

									} else {
										checktrue = "no";
										$js('<style>#zooomyalertbtn { opacity:0.6;pointer-events:none;}</style>').appendTo("body");
										double_opt = "no";

									}
								});

							}
							if (tc_txt != "" && $js("#zooomybackinstock #zooomybistc").length === 0) 
							{
								$js("<div style='font-size:12px;float:left;width:100%;padding:5px 0;' id='zooomybistc'>" + tc_txt + "</div>").insertAfter('#zooomyalertbtn');

							}

							$js('form[action="/cart/add"] select#ProductSelect-product-template').addClass("zooomybisalert");
							$js('form[action="/cart/add"] .Select.Select--primary select').addClass("zooomybisalert");
							$js('form[action="/cart/add"] select.no-js-required, form[action="/cart/add"] select.no-js').addClass("zooomybisalert");
							$js('form[action="/cart/add"] input[name="id"]').addClass("zooomybisalert");
							$js('form .variant-selection select[name="id"]').addClass("zooomybisalert");
							$js('form[action="/cart/add"] select[name="id"]').addClass("zooomybisalert");

							if ($js('.single-option-selector').length == 0) {
								$js('.option-selectors .selector-wrapper select').addClass("single-option-selector");
								$js('form .option-select-input').addClass("single-option-selector");
								$js('.select__select').addClass("single-option-selector");
								$js('select.product-variant-container').addClass("single-option-selector");

							}
                       
                            if ( cartvalues.available === false || (cartvalues.available === true && cartvalues.variants[0].inventory_management === null) )                                
                                {

								$js("#zooomybackinstock").show();
							} else {
								$js("#zooomybackinstock").hide();
							}

							if (cartvalues.variants.length < 2) {
							 if ( cartvalues.available === false || (cartvalues.available === true && cartvalues.variants[0].inventory_management === null) )  
                               {

									$js("#zooomybackinstock").show();
								} else {
									$js("#zooomybackinstock").hide();
								}
								vsku = cartvalues.variants[0].sku;
							} else {


								function getvariant(varid, allvariants) {
									for (i = 0; i < allvariants.length; i++) {
										if (allvariants[i].id == varid) {
											return allvariants[i]
										}
									}
								}
								var vars = [],
									hash;
								var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
								for (var i = 0; i < hashes.length; i++) {
									hash = hashes[i].split('=');
									vars.push(hash[0]);
									vars[hash[0]] = hash[1];
								}
								var checkdata = hash[1];


								function getUrlVars() {
									var vars = [],
										hash;
									var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
									for (var i = 0; i < hashes.length; i++) {
										hash = hashes[i].split('=');
										vars.push(hash[0]);
										vars[hash[0]] = hash[1];
									}
									return vars;
								}
								me = getUrlVars()["variant"];

								if (me == "undefined") {
									me = checkdata;
								}
								if (me == "") {
									me = checkdata;
								}

								if (me == "" || me == "undefined" || me == undefined) {
									if (('select.zooomybisalert').length) {
										me = $js(".zooomybisalert option:selected").val();

									}
									if (me == "" || me == "undefined" || me == undefined) {
										me = $js(".zooomybisalert").val();
									}
									if (me == "" || me == "undefined" || me == undefined) {

										me = $js('.zooomybisalert').find("option:first-child").val();

									}
								}
								if (me != undefined) {
									getvariantid = getvariant(me, cartvalues.variants);

									if (getvariantid) {
										if (getvariantid.available == false || (getvariantid.available === true && getvariantid.inventory_management === null)) {
											$js("#zooomybackinstock").show();

											vtitle = getvariantid.title;
											if (getvariantid.featured_image != null) {
												variant_img = getvariantid.featured_image.src;

											}
											if (vsku == "" || vsku == undefined || vsku == null) {
												vsku = getvariantid.sku;


											}

										}
										if (getvariantid.available == true && getvariantid.inventory_management === "shopify") {

											$js("#zooomybackinstock").hide();

										}
									}



								}

								changefunction = ".single-option-selector";
								changeaction = "change";

								if ($js('form[action="/cart/add"]  input[type="radio"]').length) {
									changefunction = 'form[action="/cart/add"]  input[type="radio"]';
								}

								if ($js('.no-js-hidden .product-form__input input[type="radio"]').length) {
									changefunction = 'fieldset.product-form__input input[type="radio"]';
									changeaction = "change";

								}
								if ($js('.variant-wrapper input[type="radio"]').length) {
									changefunction = '.variant-wrapper input[type="radio"]';
									changeaction = "change";

								}
								if ($js('.option-selector__btns input[type="radio"]').length) {
									changefunction = '.option-selector__btns input[type="radio"]';
									changeaction = "change";

								}
								if ($js('.ProductForm__Variants input[type="radio"]').length) {
									changefunction = '.ProductForm__Variants  input[type="radio"]';
									changeaction = "change";

								}
								if ($js('.product-form input[type="radio"]').length) {
									changefunction = '.product-form input[type="radio"]';
									changeaction = "change";

								}

								if ($js('form .swatch__options input[type="radio"]').length) {
									changefunction = 'form .swatch__options input[type="radio"]';
								}

								if ($js('.product__details .product__controls-group button').length) {
									changefunction = '.product__details .product__controls-group button';
									changeaction = "click";
								}

								if ($js('.variant-swatch-king .swatch-selector').length) {
									changefunction = '.variant-swatch-king .swatch-selector';
									changeaction = "change";
								}
								if ($js('.selector-wrapper input[type="radio"]').length) {
									changefunction = '.selector-wrapper input[type="radio"]';
								}

								if ($js('form[action="/cart/add"]  .single-option-selector').length) {
									changefunction = 'form[action="/cart/add"]  .single-option-selector';
								}
								if ($js('.product-single__box variant-radios  input[type="radio"]').length) {
									changefunction = '.product-single__box variant-radios  input[type="radio"]';
								}

								if ($js('.variant-wrapper input[type="radio"]').length && $js('.variant-wrapper .single-option-selector').length) {
									changefunction = '.variant-wrapper input[type="radio"], .variant-wrapper .single-option-selector';
									changeaction = "change";
								}

								if ($js('.ProductForm__Option #Block-variant_picker .Form__Select.single-option-selector').length) {
									changefunction = '.ProductForm__Option #Block-variant_picker .Form__Select.single-option-selector';
									changeaction = "change";
								}
								if ($js('.product__dropdown .input__select-wrapper').length) {
									changefunction = '.product__dropdown .input__select-wrapper';
									changeaction = "click";
								}
								if ($js('variant-selects .product-form__input input[type="radio"]').length) {
									changefunction = 'variant-selects .product-form__input input[type="radio"]';
								}
								if ($js('variant-picker .variant-picker__option input[type="radio"]').length) { 
									changefunction = 'variant-picker .variant-picker__option input[type="radio"]';
								}
		                        if ($js('variant-picker .product-variant-picker__list').length) { 
		                            changefunction = 'variant-picker .product-variant-picker__list';
		                            changeaction = "click";

		                        }
								if ($js('.product-form__controls .product-form__controls-group input[type="radio"]').length) { 
									changefunction = '.product-form__controls .product-form__controls-group input[type="radio"]';
								}
								if ($js('.shopify-product-form .product-options_custom button').length) { 
									changefunction = '.shopify-product-form .product-options_custom button';
		                            changeaction = "click";
									
								}
								if ($js('.prod-vars').length) { 
									changefunction = '.prod-vars';
		                            changeaction = "click";
									
								}	
								if ($js('.swatch-items-wrapper .swatch-element').length) { 
									changefunction = '.swatch-items-wrapper .swatch-element';
		                            changeaction = "click";
									
								}	

				console.log(changefunction);
								$js(changefunction).on(changeaction, function() {

									setTimeout(function() {
										if (('select.zooomybisalert').length > 0) {

											me = $js(".zooomybisalert option:selected").val();
											var vautotitle = $js(".zooomybisalert option:selected").text();
											vtitle = vautotitle.trim();
										}

										if (me == "" || me == "undefined" || me == undefined) {
											me = $js(".zooomybisalert").val();
										}
										if (me == "" || me == "undefined" || me == undefined) {
											me = $js("input[name=id]").val();
										}
		                                if(shop=="toneoptic.myshopify.com")
		                                {
		                                    me = $js(".product-form input[name=id]").val();

		                                }
		                         					

										if (me == "") {
											function getUrlVars() {
												var vars = [],
													hash;
												var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
												for (var i = 0; i < hashes.length; i++) {
													hash = hashes[i].split('=');
													vars.push(hash[0]);
													vars[hash[0]] = hash[1];
												}
												return vars;
											}
											me = getUrlVars()["variant"];
										}


										if (me == "undefined") {
											me = checkdata;
										}
										if (me == "") {
											me = checkdata;
										}
										if (me != undefined) {
											getvariantid = getvariant(me, cartvalues.variants);

											if (getvariantid) {

												if (getvariantid.available == false) {
													$js("#zooomybackinstock").show();
													if (vtitle == "" || vtitle == undefined || vtitle == null) {
														vtitle = getvariantid.title;

													}

													if (getvariantid.featured_image != null) {
														if (variant_img == "" || variant_img == undefined || variant_img == null) {
															variant_img = getvariantid.featured_image.src;
														}

													}


													vsku = getvariantid.sku;




												}
												if (getvariantid.available == true) {

													$js("#zooomybackinstock").hide();

												}
											}



										}
									}, 250);
								});

							}
							if (me == "") {
								me = vid;
							}


							$js('#zooomyalertbtn').click(function() {
								$js("p.zooomystockmsg").replaceWith("<p></p>");
								if (znlsignup == "yes") 
								{
									if (document.getElementById('zbisnl').checked) 
									{
										znlcheck = 'yes';
									}
								}
								if(bislayout=="popup")
								{
							     me = $js(".zbisselect").val();
								 vsku   = $js(".zbisselect option:selected").data("sku");
								variant_img = $js(".zbisselect option:selected").data("image");
								}
								console.log(me);
								var zooomyalertemail = $js("#zooomyalertemail").val();
								$js.ajax({
									url: "https://zooomyapps.com/backinstock/zooomybackinstock.php",
									data: {
										vsku: vsku,
										znlcheck: znlcheck,
										double_opt: double_opt,
										shop: shop,
										product_id: product_id,
										product_handle: product_handle,
										customer_name: customer_name,
										customer_email: customer_email,
										variant_id: me,
										title: protitle,
										img: proimg,
										price: proprice,
										vtitle: vtitle,
										zooomyalertemail: zooomyalertemail,
										variant_img: variant_img,
										lang_s: lang_s
									},
									dataType: "jsonp",
									jsonp: "ZooomyGetDataPage",
									async: "true",
									success: function(njsonData) {
										var already_added = " ";
										already_added = njsonData.already_added;
										
										$js('#zooomybackinstock input[type="email"]').val('');

									if ($js("#zooomybackinstock .zooomystockmsg").length === 0) {


										if (njsonData.emailcheck == "Valid") {
											$js("#zooomybackinstock").append("<p class='zooomystockmsg'>" + notify_msg + "</p>");

										}
										if (njsonData.emailcheck == "Invalid") {
											$js("#zooomybackinstock").append("<p  class='zooomystockmsg'>" + notify_emsg + "</p>");

										}

										if (already_added == "" || already_added == undefined) {} else {
											$js("#zooomybackinstock").append("<p  class='zooomystockmsg'>" + njsonData.already_added + "</p>");

										}
									}
									}
								});


								if (maillist == "yes") {
									var zooomyalertemail = $js("#zooomyalertemail").val();

									$js.ajax({
										url: "https://zooomyapps.com/backinstock/klaviyo/ZooomyFrontendAjax.php",
										data: {
											znlcheck: znlcheck,
											customer_email: zooomyalertemail,
											customer_name: customer_name,
											shop: shop,
											product_title: protitle
										},
										dataType: "jsonp",
										jsonp: "ZooomyGetMail",
										async: "true",
										success: function(mailJsonData) {

										}
									});
								}


							});
							document.addEventListener('keypress', (event) => {
								if (event.target.id === 'zooomyalertemail' && event.keyCode === 13) {
									const input = event.target;
									event.preventDefault();
									event.stopPropagation();
									const button = document.getElementById('zooomyalertbtn');
									if (button) {
										button.click();
									}
								}
							});


							if (autoemail == "yes" && send_email > 0) {
								var allv = [];

								for (i = 0; i < cartvalues.variants.length; i++) {
									if (cartvalues.variants[i].available == true) {
										valv = cartvalues.variants[i].id;
										allv.push(valv);
									}
								}

		                        if(jsonData.fae=="yes")
		                        {
								if (allv.length === 0) {

								} else {

									$js.ajax({
										url: "https://zooomyapps.com/backinstock/send-mail/zooomy_email_check.php",
										data: {
											shop: shop,
											product_id: product_id,
											product_handle: product_handle,
											variant_id: allv,
											title: protitle,
											img: proimg,
											shop_token: shop_token,
											lang_s: lang_s
										},
										dataType: "jsonp",
										jsonp: "ZooomyAutoEmail",
										async: "true",
										success: function(njsonData) {

										}
									});
								}
		                    }

							}
						}

					});

					$js('<style>#zooomybackinstock > div{display:block!important;}</style>').appendTo("body");
					$js('<style>' + ccss + '</style>').appendTo("body");
					$js('<style>' + user_added_css + '</style>').appendTo("body");

				}

			});

		}


    function zooomyPopup(){

		$js('#zooomybackinstock').append(`
		  <div class="zbis-notify-wrap">
		    <button type="button" class="zbis-notify-btn">
		      Notify me when product is available
		    </button>
		  </div>
		`);  

    // $js('#zooomybackinstock').remove();

       let style= `input#zooomyalertemail { border-radius: 5px; border: 1px solid #cbcbcb; padding: 10px; box-sizing: border-box; }.zbisselect { padding: 0px 30px; border-radius: 5px; border: 1px solid #cbcbcb; width: auto; max-width: 100%; margin-top: 10px; }.custom-zooomymodel-wrap #zooomybackinstock { padding: 0; border: 0; }.custom-zooomymodel-main {   transition: opacity .25s ease;text-align: center; overflow: hidden; position: fixed; top: 0; right: 0; bottom: 0; left: 0; /* z-index: 1050; */ -webkit-overflow-scrolling: touch; outline: 0; opacity: 0; -webkit-transition: opacity 0.15s linear, z-index 0.15; -o-transition: opacity 0.15s linear, z-index 0.15; transition: opacity 0.15s linear, z-index 0.15; z-index: -1; overflow-x: hidden; overflow-y: auto; } .zooomymodel-open { z-index: 99999; opacity: 1; overflow: hidden; }.custom-zooomymodel-main.zooomymodel-open .custom-zooomymodel-inner{ opacity: 1; transform: translateY(0) scale(1); } .custom-zooomymodel-wrap { display: block; width: 100%; position: relative; background-color: #fff;border-radius:6px; border: 1px solid #999; border: 1px solid rgba(0, 0, 0, 0.2); border-radius: 6px; -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5); box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5); background-clip: padding-box; outline: 0; text-align: left; padding: 20px; -webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box; max-height: calc(100vh - 70px); overflow-y: auto; } .custom-zooomymodel-inner { opacity: 0; transform: translateY(12px) scale(.98); transition: opacity .25s ease, transform .25s ease; will-change: opacity, transform; display: inline-block; vertical-align: middle; width: 400px; margin: 30px auto; max-width: 97%; }.zooomymodel-open .custom-zooomymodel-inner { -webkit-transform: translate(0, 0); -ms-transform: translate(0, 0); transform: translate(0, 0); position: relative; z-index: 999; } .zooomymodel-open .bg-overlay { background: rgba(0, 0, 0, 0.85); z-index: 99; } .bg-overlay { background: rgba(0, 0, 0, 0); height: 100vh; width: 100%; position: fixed; left: 0; top: 0; right: 0; bottom: 0; z-index: 0; -webkit-transition: background 0.15s linear; -o-transition: background 0.15s linear; transition: background 0.15s linear; } .close-btn { position: absolute; right: 0; top: -35px; cursor: pointer; z-index: 99; font-size: 30px; color: #fff; } @media screen and (min-width:800px){ .custom-zooomymodel-main:before { content: ""; display: inline-block; height: auto; vertical-align: middle; margin-right: -0px; height: 100%; } } @media screen and (max-width:799px){ .custom-zooomymodel-inner{margin-top: 45px;} }`
       let popupHtml = `<div class="custom-zooomymodel-main">
                      <div class="custom-zooomymodel-inner">        
                      <div class="close-btn">×</div>
                          <div class="custom-zooomymodel-wrap">
                              <div class="pop-up-content-wrap" id="zooomybackinstock">
                                 
                              </div>
                          </div>  
                      </div>  
                      <div class="bg-overlay" style="display:block"></div>
                  </div> `;
        
        $js("body").append(popupHtml+`<style>${style}</style`)
        $js(".zbis-notify-wrap").on('click', function() {
          $js(".custom-zooomymodel-main").addClass('zooomymodel-open');
        }); 
        $js(".close-btn, .bg-overlay").click(function(){
         $js(".custom-zooomymodel-main").removeClass('zooomymodel-open');
        });
        $js("body").on("click","#zooomyalertbtn",function(){
           setTimeout(function () {
             $js(".custom-zooomymodel-main").removeClass('zooomymodel-open');
           },2000) 
        });

	$js(document).on('click', '.custom-zooomymodel-main', function (e) {
	  if ($js(e.target).closest('.custom-zooomymodel-inner').length === 0) {
	    $js(this).removeClass('zooomymodel-open');
	  }
	});

	// Prevent inside clicks from closing
	$js(document).on('click', '.custom-zooomymodel-inner', function (e) {
	  e.stopPropagation();
	});

    }

}

  function reqJquery() {
    if ("undefined" == typeof jQuery || !jQuery || (1 === parseInt(jQuery.fn.jquery) && 11 > parseFloat(jQuery.fn.jquery.replace(/^1\./, "")))) {
        var o = document.getElementsByTagName("head")[0],
            t = document.createElement("script");
        (t.src = "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.1/jquery.min.js"),
            (t.type = "text/javascript"),
            (t.onload = t.onreadystatechange = function () {
                t.readyState ? ("complete" !== t.readyState && "loaded" !== t.readyState) || ((t.onreadystatechange = null), zooomyBT(jQuery.noConflict(!0))) : zooomyBT(jQuery.noConflict(!0));
            }),
            o.appendChild(t);
    } else zooomyBT(jQuery);
}
typeof meta !="undefined"  && "product" == meta.page.pageType ? setTimeout(reqJquery, 600) : reqJquery();